export default {"src":"/_next/static/media/ic-double.3c1ee63a.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};